export var diamondBackground = '$_245mT';
export var minHeight = '$_21Sei';
export var forcedMarginAuto = '_2m1sb';